import { TSortDirection } from "../Elements/Tables/organisms/Table/Interfaces/Interfaces"
import { TReactSelectOption } from "./ExternalComponentsInterfaces"

export interface ISettings {
	connection: IConnection
	formsConfigs: IFormsConfig[]
	personalize: IPersonolize
	// TODO-1898/TODO-1331
	// savedRequestFormButtons: ISavedRequestFormButton[]
	emailField: IEmailField
	additionalInfo: IAdditional
}

export interface IFormsConfig {
	id: string
	name: string | null
	nameURL?: string
	position: number
	isActive: boolean
	itemType: IItemType
	userIdField: IUserIdField
	userEmailField: IUserIdField
	userMobField: IUserIdField
	userDepField: IUserIdField
	userNameField: IUserIdField
	collections: ICollection[]
	newRequestForm: INewRequestFormField[]
	requestTable: IRequestTableFormField[]
	savedRequestForm: ISavedRequestFormField[]
}

export interface IConnection {
	tool: TToolType
	url: string
	userName: string
	password: string
}

export interface IItemType {
	id: string
	name: string
}

export interface IUserIdField {
	fieldId: string
	name: string
}
export interface IDefaultSortOrder {
	fieldId: string
	sortingOrder: string
}

export interface ICollection {
	picklistFieldId: string | null
	picklistValue: string | null
	picklistLabel: string | null
	projectId: string
	projectName: string
	folderId: string
	folderName: string
	responsibleValue: string | null
	responsibleField: string | null
}
export interface IItemOfTypeLevels {
	itemOfTypeId?: string
	isPicklistFirstSetSecond: boolean
	levelOneEnabled: boolean
	levelTwoEnabled: boolean
	firstLevelFieldNameLV: string
	firstLevelFieldNameEN: string
	secondLevelFieldNameLV: string
	secondLevelFieldNameEN: string
	picklistFieldId?: string
	stringFieldId?: string
}
export interface INewRequestFormField {
	nameLV: string
	nameEN: string
	mainFieldKey: string
	mainFieldLabel: string
	isRequired: boolean
	excludedPickListItemValues: TReactSelectOption[]
	tooltip: IToolTipText
	isMultilineField: boolean
	charLimit: string
	excludedItemOfTypeValues: TReactSelectOption[]
	isConditional: boolean
	predicateFieldKey: string
	predicateValues: TReactSelectOption[]
	fieldType: TNewRequestFormFieldType
	picklistId?: string | null
	pickListValues?: TReactSelectOption[]
	itemOfTypeBooleanFieldId: string
	itemOfTypeBooleanItemId: string
	itemOfTypeUserFieldId: string
	itemOfTypeUserItemId: string
	itemOfTypeLevels: IItemOfTypeLevels
	itemOfTypeId?: string
}

export interface IRequestTableFormField {
	/**
	 * field name shown in table
	 */
	nameLV: string
	nameEN: string
	/**
	 * field id/key/label from tool
	 */
	mainFieldKey: string
	mainFieldLabel: string
	/**
	 * Is column serachable in table
	 */
	searchable: boolean
	/**
	 * Is column sortable in table
	 */
	sortable: boolean
	/**
	 * Is column default sort field
	 */
	isDefaultSortField: boolean
	/**
	 * Is column sorted ascending or descending
	 */
	defaultSortOrder: TSortDirection
	type: string
}

export interface ISavedRequestFormField {
	/**
	 * Section name from user input
	 */
	nameEN: string
	nameLV: string
	/**
	 * Main field value
	 */
	mainFieldKey: string
	/**
	 * Main field label
	 */
	mainFieldLabel: string
	/**
	 * User submitted value in tool's request
	 */
	fieldType: string
	/**
	 * User submitted value in tool's request
	 */
	value?: string
	/**
	 * Fields background color
	 */
	color?: string | null
}

export interface ISavedRequestFormButton {
	label: string
	statusFrom: string
	statusTo: string
}
export interface IPersonolize extends IColor {
	bigLogo: boolean
}
export interface IColor {
	colorHeader: string
	colorButton: string
	colorHeaderText: string
	colorButtonText: string
}
export interface IEmailField {
	sendEmail: boolean
	emailType: TReactSelectOption[]
	notificationText: string
}
export interface IEmailConfig {
	smtpHost: string
	smtpPort: string
	smtpUser: string
	smtpPass: string
	emailFrom: string
	isSecureConnection: boolean
	isAnonymous: boolean
	isCompleted: boolean
}

export interface IToolTipText {
	textLV: string | undefined
	textEN: string | undefined
	isRichText?: boolean
	isModal?: boolean
}

export type TDefinedToolTypes = "userSideAttachments"

export type IToolTipTexts = {
	[id in TDefinedToolTypes]: IToolTipText
}

export type ISubmitTexts = {
	notificationTextLV: string
	notificationTextEN: string
	isEnabled: boolean
}
// can be used in future for other client requests
export interface IAdditional {
	welcomeTextLV: string
	welcomeTextEN: string
	/** Contains all tooltip texts as children */
	toolTipTexts: IToolTipTexts
	submitText: ISubmitTexts
	cookieBar: IToolTipText
}

export type TToolType = "jama"
export const isToolType = (candidate: string): candidate is TToolType => {
	if (candidate != "jama") return false
	return true
}

export type TAllForms =
	| IConnection
	| IItemType
	| INewRequestFormField
	| IRequestTableFormField
	| ISavedRequestFormField
	| ICollection
	| IColor

export type TNewRequestFormFieldType =
	| "STRING"
	| "NUMBER"
	| "PICKLIST"
	| "RICHTEXT"
	| "DATE"
	| "ITEM_OF_TYPE"
	| "MULTI_PICKLIST"
	| "ATTACHMENT"
	| "UNSETTABLE"
	| "USER_UNSETTABLE"
	| "CHECK"
	| "PHONE"
	| "SELECT"

export type TUserField =
	| "userIdField"
	| "userEmailField"
	| "userMobField"
	| "userDepField"
	| "userNameField"
	| "itemType"
